export default __webpack_public_path__ + "static/media/cistilo_stekla.7d872957.svg";